import React from "react";
import Select from 'react-select';

const customStyles = {
  menu: (provided, state) => ({
    ...provided,
    width: 280,
    zIndex: 2,
    right: 0
  }),

  dropdownIndicator: () => ({
  }),
}

const getOptionValue = (option) => {
  return option.name
}


const getOptionLabel = (option) => {
  let font = option.value;
  if (font) {
    const fontPreview = font && font.preview && font.preview.length > 0 ? (
      <img
      style={{ fontFamily: font.title }}
      src={font.preview[0].url}
      alt={font.title}
      height="25px"
      loading="lazy"
    />) : font.title;
    return ( font && <span style={{ fontFamily: font.title }}>{fontPreview}</span>);
  }
  
}


const FontSelectField = props => {
  const { input, fonts, defaultStyles } = props;
  const fontOptions = fonts.map((font) => {
    return ({ value: font, label: font.title, name: font.title});
  });
  return (
    <Select 
      {...input} 
      onChange={value => input.onChange(value)} 
      onBlur={event => event.preventDefault()}
      options={fontOptions}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      styles={defaultStyles ? {} : customStyles}
      isSearchable={true}
    />
  )
}

export default FontSelectField;